import { MdFormat } from "./types"

export const getCaret = (node:HTMLElement, cnt:number=0, which:'start'|'end'='end') => {
  try {
    const sel = window.getSelection()
    if (!sel) return null
    const range = sel.getRangeAt(0)
    var preCaretRange = range.cloneRange()
    if (which === 'start') {
      preCaretRange.selectNodeContents(node)
      preCaretRange.setEnd(range.startContainer, range.startOffset)
    }
    else {
      preCaretRange.selectNodeContents(node)
      preCaretRange.setEnd(range.endContainer, range.endOffset)
    }

    const documentFragment = preCaretRange.cloneContents()

    var div = document.createElement('div')
    div.appendChild(documentFragment)

    const frag = decodeHtml((div.innerHTML).replace(/<\/(p|div|h1|h2|h3)>\n?<[^>]+>/g, "\n").replace(/<[^>]+>/g, ''))
    return frag.length
  }
  catch(e) {
    console.warn(e)
    return 1
  }
}

export const goto = (node:Node, pos:number, rootNode:Node|null) => {
  // console.log(`Goto ${pos} in node `, node)
  if ((node.nodeValue === "\n") && (node.nextSibling)) {
    node = node.nextSibling.childNodes[0];
    pos=0
  }
  const range = document.createRange()
  if (node) {
    range.setStart(node, pos)
    range.setEnd(node, pos)
  }
  const selection = window.getSelection()
  if ((selection) && (rootNode?.contains(selection.anchorNode))) {
    selection.removeAllRanges()
    selection.addRange(range)
  }
}

export const setCaret = (node:Node|null, pos:number, offset=0, rootNode:Node|null=null) => {
  if (rootNode === null) rootNode=node
  if (offset<0) return -1
  if (!node) return -1
  // console.log(`setCaret(${pos}) is in node ${node.nodeType}:${node.nodeName} with offset ${offset}: `, node)
  if (node.nodeType === 3) {
    const length = node.textContent ? node.textContent.length : 0
    if ((offset <= pos) && (pos <= offset+length)) {
      goto(node, pos - offset, rootNode)
      return -1
    }
    offset += length
  }
  else if (node.childNodes.length) node.childNodes.forEach((n) => {
    if (n.nodeType === 3) {
      offset = setCaret(n, pos, offset, rootNode)
      if (offset<0) return -1
    }
    else {
      offset = setCaret(n, pos, offset, rootNode)
      if (offset<0) return -1
    }
  })
  else if (node.nodeName === 'P') {
    //console.warn(`SET HERE? ${(pos === offset)}`, node)
    if (pos === offset) goto(node, 1, rootNode)
    return -1
  }
  return offset
}

export function decodeHtml(html:string) {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}

export const checkWhitelist = (tag:MdFormat, whitelist:MdFormat[]|null = null) => {
  //console.log(`${tag}: ${ ((whitelist === null) || (whitelist.indexOf(tag) > -1)) ? 'is allowed ': 'is NOT allowed'} (${whitelist?.indexOf(tag)}) -- [${whitelist?.join(', ')}]`)
  if ((whitelist === null) || (whitelist.indexOf(tag) > -1)) return true
  return false
}